const primaryNavigation = [
  { label: "Shop All", href: "/shop" },
  {
    label: "Spices & Seasonings",
    href: "/collections/spices-seasonings-herbs",
    children: [
      {
        label: "Spices",
        href: "/shop",
        children: [
          { label: "Ground Spices", href: "/collections/ground-spices" },
          { label: "Whole Spices", href: "/collections/whole-spices" },
          { label: "Best Sellers", href: "/shop?collection=best-sellers" },
        ],
      },
      {
        label: "Seasonings & Herbs",
        href: "/shop?collection=seasonings-herbs",
        children: [
          { label: "Seasoning Blends", href: "/collections/blends" },
          { label: "Culinary Herbs", href: "/collections/herbs" },
          { label: "Small Batch", href: "/shop?tag=small-batch" },
        ],
      },
      {
        label: "Salt & Specialties",
        href: "/shop?collection=salt-specialties",
        children: [
          { label: "Gourmet Salts", href: "/collections/salts" },
          { label: "Rare Ingredients", href: "/collections/rare-ingredients" },
          { label: "Shop All", href: "/shop" },
        ],
      },
    ],
  },
  { label: "Recipes", href: "/recipes" },
  {
    label: "More",
    href: "/faq",
    children: [
      {
        label: "Help & policies",
        href: "/faq",
        children: [
          { label: "FAQs", href: "/faq" },
          { label: "Privacy Policy", href: "/privacy" },
          { label: "Cookie Policy", href: "/cookies" },
          { label: "Terms of Use", href: "/terms" },
          { label: "Shipping", href: "/shipping" },
          { label: "Returns", href: "/returns" },
        ],
      },
    ],
  },
];

const footerNavigation = [
  {
    title: "Explore",
    links: [
      { label: "Shop All", href: "/shop" },
      { label: "Best Sellers", href: "/shop?collection=best-sellers" },
      { label: "Recipes", href: "/recipes" },
      { label: "Our Story", href: "/about" },
    ],
  },
  {
    title: "Customer Care",
    links: [
      { label: "Shipping", href: "/shipping" },
      { label: "Returns", href: "/returns" },
      { label: "FAQ", href: "/faq" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", href: "/privacy" },
      { label: "Cookie Policy", href: "/cookies" },
      { label: "Terms", href: "/terms" },
    ],
  },
];

const siteConfig = {
  brandName: "madezuno",
  displayName: "madezuno",
  shortName: "madezuno",
  storageNamespace: "madezuno",
  tagline: "Every jar has a place on the map.",
  description:
    "Vivid, thoughtfully sourced spices, herbs, salts, and small-batch blends for curious everyday cooks.",
  logo: {
    text: "madezuno",
    monogram: "M",
    image: null,
  },
  contact: {
    email: "block@madezuno.life",
    address: {
      line1: "33 Kingswear Ave",
      city: "Singapore",
      region: "",
      postalCode: "557214",
      country: "Singapore",
      formatted: "33 Kingswear Ave, Singapore 557214",
    },
    hours: "Monday–Friday, 9am–5pm ET",
  },
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  shipping: {
    freeThreshold: 0,
    standardRate: 9.99,
    expressRate: 9.99,
    standardLabel: "Standard shipping",
    expressLabel: "Express shipping",
    estimatedDelivery: "3–6 business days",
    expressDelivery: "1–2 business days",
    domesticRegion: "supported delivery destinations",
  },
  returns: {
    windowDays: 30,
    unopenedOnly: true,
    returnShippingFee: 6.95,
    nonReturnable: ["Opened food products", "Gift cards", "Final-sale items"],
  },
  support: {
    responseTime: "within two business days",
  },
  announcement: "Flat-rate shipping $9.99 · Ground fresh in small batches",
  navigation: primaryNavigation,
  footerNavigation,
  socialLinks: [],
  routes: {
    home: "/",
    shop: "/shop",
    cart: "/cart",
    checkout: "/checkout",
    wishlist: "/wishlist",
    recipes: "/recipes",
  },
  seo: {
    defaultTitle: "madezuno | Remarkable spices for everyday cooking",
    titleTemplate: "%s | madezuno",
    defaultDescription:
      "Explore thoughtfully sourced spices, fragrant herbs, finishing salts, and original blends from madezuno.",
    locale: "en_US",
  },
};

const formatCurrency = (amount, options = {}) => {
  const minimumFractionDigits =
    options.minimumFractionDigits ??
    (Number.isFinite(options.maximumFractionDigits)
      ? Math.min(2, options.maximumFractionDigits)
      : 2);

  return new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
    minimumFractionDigits,
    ...options,
  }).format(Number(amount) || 0);
};

export { siteConfig, primaryNavigation, footerNavigation, formatCurrency };
export default siteConfig;
